import type { ChatSessionID, UserID, VideoID } from '@/models/ids';
import type { ChatSessionType, ChatSessionClosureType } from '@/models/enums';
import type { RFC3339 } from '@/models/base-types';

export interface ChatSession {
  id: ChatSessionID;
  userID: UserID;

  type: ChatSessionType;
  title: string;

  videoID: VideoID | null;

  llmActive: boolean;

  closed: boolean;
  closedAt: RFC3339 | null;
  closureType: ChatSessionClosureType | null;

  created: RFC3339;
  updated: RFC3339 | null;
  deleted: RFC3339 | null;
}

// Helper function to identify video chat sessions
export const isVideoChat = (session: ChatSession): boolean => {
  return session.type === 'VIDEO_SESSION' || (session.videoID !== undefined && session.videoID !== null);
};
